import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialMediaLinks = () => {
  const socialLinks = [
    {
      id: 1,
      platform: "GitHub",
      icon: "Github",
      url: "https://github.com/CySec-JoeSchmo/",
      username: "@CySec-JoeSchmo",
      color: "hover:bg-slate-700"
    },
    {
      id: 2,
      platform: "LinkedIn",
      icon: "Linkedin",
      url: "https://www.linkedin.com/in/joseph-graziano-34a44530/",
      username: "Joe Graziano",
      followers: "200+",
      color: "hover:bg-blue-600"
    },
    {
      id: 3,
      platform: "X",
      icon: "Twitter",
      url: "https://twitter.com/TheGrazIT",
      username: "@TheGrazIT",
      color: "hover:bg-sky-500"
    },
    {
      id: 4,
      platform: "Medium",
      icon: "BookOpen",
      url: "https://medium.com/@thejoegraz",
      username: "@thejoegraz",
      color: "hover:bg-green-600"
    },
  ];

  const handleSocialClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <span className="inline-block px-4 py-2 bg-accent/10 text-accent rounded-full text-sm md:text-base font-medium mb-4">
            Connect
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Let's Stay Connected
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Follow me on social media for updates, insights, and behind-the-scenes content
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {socialLinks?.map((social) => (
            <button
              key={social?.id}
              onClick={() => handleSocialClick(social?.url)}
              className={`group bg-card rounded-xl md:rounded-2xl p-6 md:p-8 border border-border hover:border-accent/50 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 text-left ${social?.color}`}
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 bg-accent/10 rounded-lg md:rounded-xl flex items-center justify-center group-hover:bg-accent/20 transition-colors duration-300">
                  <Icon
                    name={social?.icon}
                    size={24}
                    color="var(--color-accent)"
                    className="md:w-7 md:h-7"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1 group-hover:text-accent transition-colors duration-300">
                    {social?.platform}
                  </h3>
                  <p className="text-sm text-muted-foreground truncate">
                    {social?.username}
                  </p>
                </div>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-border">
                <div className="flex items-center gap-2">
                  <Icon name="Users" size={16} color="var(--color-muted-foreground)" />
                  <span className="text-sm text-muted-foreground">
                    {social?.followers} followers
                  </span>
                </div>
                <Icon
                  name="ExternalLink"
                  size={16}
                  color="var(--color-accent)"
                  className="group-hover:translate-x-1 transition-transform duration-300"
                />
              </div>
            </button>
          ))}
        </div>

      </div>
    </section>
  );
};

export default SocialMediaLinks;